import { number } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useEstimateEditorSettings, useEstimateStructure, ValueCell } from "@tools";
import { capitalize, Grid } from "@material-ui/core";
import { TooltipIcon } from "@components";
import { ExpandMore } from "@material-ui/icons";
import useStyle from "./TableHeaderCell.style";
import classnames from "classnames";

export const TableHeaderCell = observer(({ monthIndex }) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { blockExpansions, isPdfPrinterView } = useEstimateEditorSettings();
  const classes = useStyle();
  
  const isOpened = structure.settings.expandedMonthList.includes(monthIndex+1);
  // const isOpened = useMemo(() => (
  //   structure.settings.isTimelineMonthExpanded(monthIndex)
  // ), [structure.settings.expandedTimelineMonths?.size]);
  
  const handleExpand = () => {
    if(blockExpansions) return;
    structure.settings.expandTimelineMonth(monthIndex, !isOpened);
  }
  
  return (
    <ValueCell
      isHeader
      alignItems="center"
      // size="small"
      className={classnames(
        "p-0",
        classes.cellContainer,
        isOpened && classes.cellExpanded
      )}
    >
      <Grid item container direction="column">
        <span className="preset-tableTimelineHeader">
          {`${capitalize(t("time.month"))} ${monthIndex+1}`}
        </span>
        {
          isOpened &&
          <Grid item container wrap="nowrap" >
            { [ 1, 2, 3, 4 ].map(week => (
              <span key={week} className={classnames("preset-tableTimelineHeader my-1", classes.weekCell)}>
                {`${capitalize(t("time.week"))} ${week}`}
              </span>
            )) }
          </Grid>
        }
      </Grid>
      {
        !isPdfPrinterView &&
        <TooltipIcon
          icon={
            <ExpandMore className={classnames("expand transition -rotate-90", isOpened && "rotate-90")} />
          }
          onClick={handleExpand}
          className={classnames(
            "noDrag absolute",
            classes.button,
            !isOpened && "cellHoverIcon",
          )}
          color="primary"
        >
          {t(`views.editor.timeline_table.${isOpened ? "hide" : "show"}_week`)}
        </TooltipIcon>
      }
    </ValueCell>
  )
})

TableHeaderCell.propTypes = {
  monthIndex: number.isRequired,
}